export default function CTA() {
  return (
    { label: "Contact", href: "#contact" },
    (
      <section
        className="bg-slate-900 text-white py-20 text-center"
        id="contact"
      >
        <h2 className="text-3xl font-bold mb-4">
          Interested in Renting a Unit?
        </h2>

        <p className="text-slate-300 mb-8">
          Contact us today to schedule a viewing.
        </p>

        <button className="bg-orange-500 px-8 py-3 rounded-md font-semibold hover:bg-orange-600">
          Send Inquiry
        </button>
      </section>
    )
  )
}
